import styled from '@emotion/styled/macro';
import { forTabletLandscapeDown, Variables } from '@enter/core';
import { Icon } from '@mdi/react';

export {
    AppSidebar as SideBar,
    AppSidebarCollapse as SidebarCollapse,
    AppSidebarCollapseButton as CollapseButton,
    AppSidebarCollapseIcon as CollapseIcon,
    AppSidebarCollapseIndent as CollapseIndent,
    AppSidebarItem as StyledSidebarItem,
    AppSidebarMenuIcon as MenuIcon,
    AppSidebarMessageCount as MessageCount,
    AppSidebarNestedCollapseButton as NestedCollapseButton,
    AppSidebarRestrictedItem as RestrictedSidebarItem,
    AppSidebarSpacer as Spacer,
    AppSidebarSubItem as CollapseSidebarItem,
    AppSidebarSubMenuIcon as SubMenuIcon,
} from '@enter/core';

export const LogoWrapper = styled.div`
    display: flex;
    height: ${Variables.topnavSize};
    padding: 20px 0 20px ${Variables.sidebarPadding};
    background-color: ${Variables.Colors.b300};

    ${forTabletLandscapeDown(`
        opacity: 0;
    `)};
`;

export const DemoModeIndicator = styled.div<{ rail?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${({ rail }) => (rail ? 'center' : 'flex-start')};
    gap: 8px;
    padding: ${({ rail }) => (rail ? '12px 0' : `12px ${Variables.sidebarPadding}`)};
    margin-top: auto;
    background-color: ${Variables.Colors.amber10};
    border-top: 2px solid ${Variables.Colors.amber30};
    color: ${Variables.Colors.n70};
    font-size: 13px;
    font-weight: 500;
`;

export const DemoModeText = styled.span`
    color: ${Variables.Colors.amber30};
    font-weight: 600;
`;

export const ResourceLinks = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    /* Lines up with the nav items' icons; the footer above already draws the rule. */
    padding: 8px 0 10px 22px;
`;

export const ResourceLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
    text-decoration: none;
    color: #3e4d64;
    font-size: 14px;
    font-weight: 600;

    &:hover {
        text-decoration: underline;
    }

    & + & {
        margin-top: 12px;
    }
`;

export const ResourceDivider = styled.div`
    width: 50%;
    height: 1px;
    margin: 10px 0 8px;
    background-color: #e0e5ec;
`;

export const ResourceLinkText = styled.span`
    line-height: 1.4;
`;

export const ResourceLinkIcon = styled(Icon)`
    fill: ${Variables.Colors.sidebarIconColor};
    flex-shrink: 0;
`;

export const PasswordRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 6px;
    font-size: 13px;
    color: ${Variables.Colors.n70};
`;

export const PasswordLabel = styled.span`
    color: ${Variables.Colors.n70};
`;

export const PasswordValueRow = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

export const PasswordValue = styled.span<{ clickable: boolean }>`
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 14px;
    color: #1f2d3d;
    cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

    &:hover {
        text-decoration: ${({ clickable }) => (clickable ? 'underline' : 'none')};
    }
`;

export const PasswordToggle = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
`;

export const PasswordToggleIcon = styled(Icon)`
    fill: ${Variables.Colors.sidebarIconColor};
`;

export const CopiedText = styled.span`
    font-size: 12px;
    color: #3e4d64;
`;
